import withGlobalDialog from './with-global-dialog';
import withGlobalConfirmDialog from './with-global-confirm-dialog';
import withGlobalPromptDialog from './with-global-prompt-dialog';
import withGlobalExceptionDetailDialog from './with-global-exception-detail-dialog';
import withGlobalLoginDialog from './with-global-login-dialog';

export default withGlobalDialog;

export {
  withGlobalConfirmDialog,
  withGlobalPromptDialog,
  withGlobalExceptionDetailDialog,
  withGlobalLoginDialog,
};
